import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { validateDealerId } from '@app/shared/validators/dealer-id.validator';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { confirmations, httpCustomErrors } from '@app/shared/app-settings';

@Component({
  selector: 'app-dealer-reset-password',
  templateUrl: './dealer-reset-password.component.html',
  styleUrls: ['./dealer-reset-password.component.scss']
})
export class DealerResetPasswordComponent implements OnInit {

  dealerForm: FormGroup;
  @Input()
  resetComplete: boolean;
  @Input()
  resetSuccess: boolean;
  @Input()
  resetCofirmationTitle: string;
  @Input()
  resetCofirmationMessage: string;
  loading = false;

  constructor(
    private readonly dealerAuthenticationService: AuthenticationService,
    private readonly activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.initForm();
    this.loading = false;
  }

  onSubmit() {
    this.resetPassword();
  }

  onCancelClick() {
    this.closeActiveModal();
  }

  private initForm() {
    this.dealerForm = new FormGroup({
      licenseId: new FormControl('', [Validators.required, validateDealerId])
    });
  }

  private closeActiveModal() {
    this.activeModal.dismiss();
  }

  private resetPassword() {
    this.loading = true;
    this.dealerAuthenticationService.resetPassword(this.dealerForm.value).subscribe(
      () => {
        this.resetCofirmationTitle = confirmations.passwordReset.title;
        this.resetCofirmationMessage = confirmations.passwordReset.description;
        this.resetSuccess = true;
        this.resetComplete = true;
        this.loading = false;
      },
      () => {
        this.resetCofirmationTitle = httpCustomErrors.errorTitle;
        this.resetCofirmationMessage = httpCustomErrors.passwordReset;
        this.resetSuccess = false;
        this.resetComplete = true;
        this.loading = false;
      }
    );

    // this.closeActiveModal();
  }

}
